export function DownChevron({ className }: { className?: string }) {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 10 10"
				height={10}
				width={10}
				className={className}
			>
				<path
					fill="currentColor"
					d="M5 7.874a1.238 1.238 0 0 1 -0.879 -0.364L0.206 3.393A0.75 0.75 0 0 1 1.294 2.36l3.525 3.712a0.249 0.249 0 0 0 0.362 0L8.706 2.36a0.75 0.75 0 1 1 1.088 1.033L5.9 7.5a1.27 1.27 0 0 1 -0.9 0.374Z"
					strokeWidth={1}
				/>
			</svg>
		</>
	)
}
